import { useTranslator } from "@eo-locale/react";

import { MdOutlineEmail } from "react-icons/md";

import { Button, HStack, Text, VStack } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

interface GuestLoginOptionsProps {
  onEmailLogin: () => void;
  extraQueryParams?: Record<string, any>;
}

const GuestLoginOptions = ({
  onEmailLogin,
  extraQueryParams
}: GuestLoginOptionsProps) => {
  const { translate } = useTranslator();
  const { disableSignup } = useAppSelector((state) => state.settings.settings);

  const buildUrlWithParams = (basePath: string) => {
    const params = new window.URLSearchParams();

    // Preserve current URL with all query params as 'next'
    const currentUrl = new window.URL(window.location.href);

    // Add extraQueryParams to current URL
    if (extraQueryParams) {
      Object.entries(extraQueryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          currentUrl.searchParams.set(key, String(value));
        }
      });
    }

    // Set the modified current URL as 'next' parameter
    params.set("next", `${currentUrl.pathname}${currentUrl.search}`);

    return `${basePath}?${params.toString()}`;
  };

  const handleSignIn = () => {
    const loginUrl = buildUrlWithParams("/login");
    window.location.href = loginUrl;
  };

  const handleRegister = () => {
    const registerUrl = buildUrlWithParams("/register");
    window.location.href = registerUrl;
  };

  return (
    <VStack gap={3} align="stretch">
      <Text>
        {translate("profileGate.weWillSendATimeCodeTakesLessThanAMinute")}
      </Text>
      <VStack align="center" gap={4} width="100%">
        <Button
          width="100%"
          variant="primary"
          leftIcon={<MdOutlineEmail />}
          onClick={onEmailLogin}
        >
          {translate("profileGate.continueWithEmail")}
        </Button>
        <Text>{translate("common.or")}</Text>
        <Button width="100%" variant="secondary" onClick={handleSignIn}>
          {translate("profileGate.signInWithPassword")}
        </Button>
        {!disableSignup && (
          <HStack>
            <Text>{translate("profileGate.dontHaveAnAccount")}</Text>
            <Button variant="link" onClick={handleRegister}>
              {translate("common.register")}
            </Button>
          </HStack>
        )}
      </VStack>
    </VStack>
  );
};

export default GuestLoginOptions;
